module.exports = __webpack_public_path__ + "img/loan_home.0493d6c3.png";